module.exports = __webpack_public_path__ + "../assets/fonts/Neutra2Text-Book.50d460d4b1ed283dbe03cc0c198491c9.otf";